import _taggedTemplateLiteral from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: block;\n        width: 100%; /* prevent collapsing inside non-stretching column flex */\n        height: 8px;\n      }\n\n      :host([hidden]) {\n        display: none !important;\n      }\n\n      [part=\"bar\"] {\n        height: 100%;\n      }\n\n      [part=\"value\"] {\n        height: 100%;\n        transform-origin: 0 50%;\n        transform: scaleX(var(--vaadin-progress-value));\n      }\n\n    </style>\n\n    <div part=\"bar\">\n      <div part=\"value\"></div>\n    </div>\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
@license
Copyright (c) 2017 Vaadin Ltd.
This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
*/
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { ProgressMixin } from './vaadin-progress-mixin.js';
import { ThemableMixin } from '@vaadin/vaadin-themable-mixin/vaadin-themable-mixin.js';
import { ElementMixin } from '@vaadin/vaadin-element-mixin/vaadin-element-mixin.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
/**
 * `<vaadin-progress-bar>` is a Web Component for progress bars.
 *
 * ```html
 * <vaadin-progress-bar min="0" max="1" value="0.5">
 * </vaadin-progress-bar>
 * ```
 *
 * ### Styling
 *
 * The following shadow DOM parts are available for styling:
 *
 * Part name | Description
 * ----------------|----------------
 * `bar` | Progress-bar's background
 * `value` | Progress-bar's foreground
 *
 * See [ThemableMixin – how to apply styles for shadow parts](https://github.com/vaadin/vaadin-themable-mixin/wiki)
 *
 * The following custom properties are available:
 *
 * Custom property | Description | Default
 * ----------------|-------------|-------------
 * `--vaadin-progress-value` | current progress value (between 0 and 1) | 0
 *
 * The following state attributes are available for styling:
 *
 * Attribute       | Description | Part name
 * ----------------|-------------|------------
 * `indeterminate` | Set to an indeterminate progress bar | :host
 *
 * @memberof Vaadin
 * @mixes Vaadin.ProgressMixin
 * @mixes Vaadin.ThemableMixin
 * @demo demo/index.html
 */

var ProgressBarElement =
/*#__PURE__*/
function (_ElementMixin) {
  _inherits(ProgressBarElement, _ElementMixin);

  function ProgressBarElement() {
    _classCallCheck(this, ProgressBarElement);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProgressBarElement).apply(this, arguments));
  }

  _createClass(ProgressBarElement, null, [{
    key: "template",
    get: function get() {
      return html(_templateObject());
    }
  }, {
    key: "is",
    get: function get() {
      return 'vaadin-progress-bar';
    }
  }, {
    key: "version",
    get: function get() {
      return '1.1.2';
    }
  }]);

  return ProgressBarElement;
}(ElementMixin(ThemableMixin(ProgressMixin(PolymerElement))));

customElements.define(ProgressBarElement.is, ProgressBarElement);
export { ProgressBarElement };